'use client';

interface SectionLabelProps {
  children: React.ReactNode;
  className?: string;
}

export function SectionLabel({ children, className = '' }: SectionLabelProps) {
  return (
    <h2
      className={`mb-6 text-[36px] leading-none tracking-[0.02em] text-[#1B2D4F] uppercase lg:mb-8 lg:text-[48px] ${className}`}
      style={{ fontFamily: 'var(--font-anton)' }}
    >
      {children}
    </h2>
  );
}
